export interface StatisticState {
  callStatisticDetail?: any,
  callStatisticGroup?: CallGroupItem[],
  callGroupings: {
    callGroup: string[],
    callGroupOptionally: string[],
  },
}

export class DetailFilterParams {
  message_direction:string = 'mt';
  date_from: string;
  date_to: string;
  originator?: string = undefined;
  recipient?: string = undefined;
  partner?: string = undefined;
  service_provider?: string = undefined;
  status?: string = undefined;
  error_code?: number = undefined;
  message_type?: string = undefined;
  start_date_from?: string = undefined;
  start_date_to?: string = undefined;
  end_date_from?: string = undefined;
  end_date_to?: string = undefined;
  template_id?: number = undefined;
  bulk_id?: number = undefined;
  operator?: string = undefined;
  broker_account_login?: string = undefined;
  partner_user_login?: string = undefined;
  id?: string = undefined;
  external_id?: string = undefined;
  ext_id1?: string = undefined;
  ext_id2?: string = undefined;
  ext_id3?: string = undefined;
  ext_id4?: string = undefined;
  ext_id5?: string = undefined;
  page_number: number = 1;

  constructor(date_from: string, date_to: string) {
    this.date_from = date_from;
    this.date_to = date_to;
  }
}

export interface DetailItem {
  id: string,
  create_date: string,
  originator: string,
  recipient: string,
  partner: string,
  service_provider: string,
  content: string,
  status: string,
  error_code: number|null,
}

export class CallDetailItemInfo {
  id: string|null = null;
  create_date: string|null = null;
  sent_date?: string = undefined;
  delivery_date?: string = undefined;
  read_date?: string = undefined;
  defer_date?: string = undefined;
  external_id?: string = undefined;
  service_provider?: string = undefined;
  originator: string|null = null;
  recipient: string|null = null;
  parent_message_id?: string = undefined;
  parent_message_channel?: string = undefined;
  bulk_id?: number = undefined;
  partner: string|null = null;
  partner_user_login?: string = undefined;
  status: string|null = null;
  error_code?: number = undefined;
  error_description?: string = undefined;
  message_type?: string = undefined;
  subject?: string = undefined;
  priority?: number = undefined;
  partner_price?: string = undefined;
  provider_price?: string = undefined;
  broker_account_login?: string = undefined;
  template_id?: string = undefined;
  connection_type?: string = undefined;
  ext_id1?: string = undefined;
  ext_id2?: string = undefined;
  ext_id3?: string = undefined;
  ext_id4?: string = undefined;
  ext_id5?: string = undefined;
}
// - - -

export class GroupFilterParams {
  message_direction: string = 'mt';
  date_from: string;
  date_to: string;
  group_by: string;
  template_id?: number = undefined;
  bulk_id?: number = undefined;
  message_type?: string|null = undefined

  constructor(date_from: string, date_to: string, group_by: string) {
    this.date_from = date_from;
    this.date_to = date_to;
    this.group_by = group_by;
  }
}

export interface CallGroupItem {
  date?: string|any;
  originator?: string;
  service_provider?: string;
  partner?: string;
  recipient_operator?: string;
  template_id?: string;
  bulk_id?: string;
  finished: number;
  not_answered: number;
  failed: number;
  rejected: number;
  deferred: number;
  duration: string;
  total: number;
  partner_price: string;
}

// - - -

export class CallGroupIncomingFilterParams {
  date_from: string;
  date_to: string;
  group_by: string;
  partner?: string = undefined;
  service_number?: string = undefined;
  originator_operator?: string = undefined;

  constructor(date_from: string, date_to: string, group_by: string) {
    this.date_from = date_from;
    this.date_to = date_to;
    this.group_by = group_by;
  }
}

export interface CallGroupIncomingItem {
  date?: string;
  service_number?: string;
  partner?: string;
  originator_operator?: string;
  finished: number;
  failed: number;
  total: number;
  duration: number;
}

export class DetailIncomingFilterParams {
  date_from: string;
  date_to: string;
  originator?: string = undefined;
  service_number?: string = undefined;
  partner?: string = undefined;
  status?: string = undefined;
  error_code?: number = undefined;
  flag?: string = undefined;

  constructor(date_from: string, date_to: string) {
    this.date_from = date_from;
    this.date_to = date_to;
  }
}

export interface DetailIncomingItem {
  id: string;
  create_date: string;
  originator: string;
  service_number: string;
  partner: string;
  content: string;
  status: string;
  error_code?: number;
}

export interface DetailIncomingItemInfo extends DetailIncomingItem {
  start_date: string;
  end_date: string;
  duration: string;
  module: string;
  originator_operator?: string;
  originator_country?: string;
  error_description?: string;
}
